import * as R from 'ramda';
/**
 * Filter useForm props from a component to avoid React warnings for invalid props.
 */
export var filterUseFormProps = R.omit([
    'fieldState',
    'resetFieldState',
    'updateFieldState',
    'isValid',
    'hasError',
    'isInitial',
    'validate'
]);
